function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsConvergentBillerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import localeKeys from './../../../locales/keys';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, EnableProspectLiteForHouseholdSelector } from '../../../reducers/selectors/customer.selectors';
import { CanMakeHouseholdChangesSelector, CurrentHouseholdSelector, CurrentHouseholdMemberSelector, CurrentMemberIsHeadOfHouseholdSelector, CsrHasHouseholdAdminAccessSelector, HeadOfHouseholdSelector, HouseholdErrorSelector, HouseholdMembersListSelector, HouseholdMoreOptionsSelector, IncludeRemovedSelector, IsFetchingHouseholdSelector, IsRemovingHouseholdSelector, SelectedHouseholdMemberSelector, ShowHouseholdSelector } from '../../../reducers/selectors/customer.household.selectors';
import { removeHousehold, retrieveCustomerHouseholds, setIncludedRemovedFilter, setSelectedHouseholdMember, updateHouseholdAndStatus } from '../../../reducers/actions/customer.household.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { getMemberBySubscriberId } from './household.helpers';
import { HOUSEHOLD_OPTION_ACTIVATE_ID, HOUSEHOLD_OPTION_EDIT_ID, HOUSEHOLD_OPTION_REMOVE_ID, HOUSEHOLD_STATE_NAME } from './household.constants';
var ACTIVE = 1;
var CustomerHouseholdController = /*#__PURE__*/function () {
  function CustomerHouseholdController($ngRedux, uiNotificationService) {
    _classCallCheck(this, CustomerHouseholdController);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
  }
  return _createClass(CustomerHouseholdController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.customerCareKeys = localeKeys;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canMakeChanges: CanMakeHouseholdChangesSelector(store),
          csrHasAdminAccess: CsrHasHouseholdAdminAccessSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentHousehold: CurrentHouseholdSelector(store),
          currentMember: CurrentHouseholdMemberSelector(store),
          currentMemberIsHeadOfHousehold: CurrentMemberIsHeadOfHouseholdSelector(store),
          enableProspectLiteForHousehold: EnableProspectLiteForHouseholdSelector(store),
          headOfHousehold: HeadOfHouseholdSelector(store),
          householdError: HouseholdErrorSelector(store),
          householdOptions: HouseholdMoreOptionsSelector(store),
          members: HouseholdMembersListSelector(store),
          includeRemoved: IncludeRemovedSelector(store),
          isConvergentBiller: IsConvergentBillerSelector(store),
          isFetchingHouseholds: IsFetchingHouseholdSelector(store),
          isRemovingHousehold: IsRemovingHouseholdSelector(store),
          selectedMember: SelectedHouseholdMemberSelector(store),
          serviceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          showHousehold: ShowHouseholdSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: fetchCodeTypesThunk,
        removeHousehold: removeHousehold,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        setIncludedRemovedFilter: setIncludedRemovedFilter,
        setSelectedHouseholdMember: setSelectedHouseholdMember,
        stateGo: stateGo,
        updateHouseholdAndStatus: updateHouseholdAndStatus
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = HOUSEHOLD_STATE_NAME;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.editHouseholdPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.editHouseholdPopupApi = event.api;
        }
      };
      this.removeHouseholdPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.removeHouseholdPopupApi = event.api;
        }
      };
      this.createMemberPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.createMemberPopupApi = event.api;
        }
      };
      if (!this.state.currentHousehold) {
        this.retrieveHouseholds();
      }
      if (!this.state.serviceAttributesLoaded) {
        this.actions.fetchCodeType(CODES.ServiceAttribute);
      }
    }
  }, {
    key: "handleClickCreateHousehold",
    value: function handleClickCreateHousehold() {
      this.editHouseholdPopupApi.open();
    }
  }, {
    key: "handleClickRemoveHousehold",
    value: function handleClickRemoveHousehold() {
      this.removeHouseholdPopupApi.open();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleHouseholdAction",
    value: function handleHouseholdAction(message, memberId) {
      var _this2 = this;
      this.uiNotificationService.success(message, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.retrieveHouseholds().then(function () {
        _this2.setSelectedMember(getMemberBySubscriberId(_this2.state.currentHousehold.Members, memberId));
      });
    }
  }, {
    key: "handleClickNewMember",
    value: function handleClickNewMember() {
      this.createMemberPopupApi.open();
    }
  }, {
    key: "retrieveHouseholds",
    value: function retrieveHouseholds() {
      var INCLUDE_REMOVED = true;
      return this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, INCLUDE_REMOVED);
    }
  }, {
    key: "setSelectedMember",
    value: function setSelectedMember(member) {
      this.actions.setSelectedHouseholdMember(!member || member.isOverview ? null : member.SubscriberId);
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(item) {
      switch (item.item.id) {
        case HOUSEHOLD_OPTION_ACTIVATE_ID:
          this.activateHousehold();
          break;
        case HOUSEHOLD_OPTION_EDIT_ID:
          this.editHouseholdPopupApi.open();
          break;
        case HOUSEHOLD_OPTION_REMOVE_ID:
          this.removeHouseholdPopupApi.open();
          break;
        default:
          break;
      }
    }
  }, {
    key: "shouldShowAssociateServices",
    value: function shouldShowAssociateServices() {
      var associatedServices = pathOr([], ['currentHousehold', 'MemberToServiceAssociations'], this.state);
      var unassociatedServices = pathOr([], ['headOfHousehold', 'services'], this.state);
      return this.state.isConvergentBiller && this.state.currentMemberIsHeadOfHousehold && (associatedServices.length || unassociatedServices.length) ? true : false;
    }
  }, {
    key: "handleIncludeRemovedClick",
    value: function handleIncludeRemovedClick() {
      this.actions.setIncludedRemovedFilter(!this.state.includeRemoved);
      this.retrieveHouseholds();
    }
  }, {
    key: "closeDialog",
    value: function closeDialog(dialogApi) {
      dialogApi.close();
    }
  }, {
    key: "activateHousehold",
    value: function activateHousehold() {
      var _this3 = this;
      this.actions.updateHouseholdAndStatus(this.state.currentCustomerId, this.state.currentHousehold, ACTIVE).then(function () {
        _this3.uiNotificationService.success(i18n.translate(localeKeys.HOUSEHOLD.REACTIVATE_HOUSEHOLD_SUCCESS), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        return _this3.retrieveHouseholds();
      }).catch(function () {
        _this3.uiNotificationService.error(_this3.state.householdError.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "removeHouseholdDialogResult",
    value: function removeHouseholdDialogResult(isRemoveHousehold) {
      var _this4 = this;
      if (isRemoveHousehold) {
        this.actions.removeHousehold(this.state.currentCustomerId, this.state.currentHousehold.Id).then(function () {
          _this4.uiNotificationService.success(i18n.translate(localeKeys.HOUSEHOLD.DIALOG.REMOVE_HOUSEHOLD.SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          return _this4.retrieveHouseholds();
        }, function () {
          _this4.uiNotificationService.error(_this4.state.householdError.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }).then(function () {
          _this4.setSelectedMember();
        });
      }
      this.closeDialog(this.removeHouseholdPopupApi);
    }
  }, {
    key: "showLoadingIndicator",
    get: function get() {
      return this.state.isFetchingHouseholds || this.state.isRemoveHousehold;
    }
  }]);
}();
export default {
  template: require('./household.html'),
  bindings: {},
  controller: CustomerHouseholdController,
  controllerAs: 'CustomerHousehold'
};